module.exports = __webpack_public_path__ + "img/icon_star.8f1ae26f.svg";